<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <div style="width: 80%; margin: auto; line-height: 26px">
        <a-form-model-item
          prop="transactionModeType"
          label="招租方式类型"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <div>
            <a-radio-group v-model="form.transactionModeType">
              <a-radio style="margin: 4px 0px" :value="1">竞价</a-radio>
              <a-radio style="margin: 4px 0px" :value="2">择优遴选</a-radio>
              <a-radio style="margin: 4px 0px" :value="3">其他竞价</a-radio>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24">
      <div style="width: 80%; margin: auto; line-height: 26px">
        <a-form-model-item
          prop="transactionMode"
          label="招租方式"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span>
              <a-radio-group v-model="form.transactionMode">
                <a-radio
                  v-if="form.transactionModeType == 1"
                  style="margin: 4px 0px"
                  :value="1"
                  >网络竞价</a-radio
                >
                <a-radio
                  v-if="form.transactionModeType == 2"
                  style="margin: 4px 0px"
                  :value="2"
                  >权重报价</a-radio
                >
                <a-radio
                  v-if="form.transactionModeType == 3"
                  style="margin: 4px 0px"
                  :value="4"
                  >其他竞价</a-radio
                >
                <a-radio
                  v-if="form.transactionModeType == 1"
                  style="margin: 4px 0px"
                  :value="5"
                  >开放报价</a-radio
                >
                <!-- <a-radio style="margin: 4px 0px" :value="6">协议转让</a-radio> -->
                <a-radio
                  v-if="form.transactionModeType == 2"
                  style="margin: 4px 0px"
                  :value="7"
                  >竞争性谈判</a-radio
                >
              </a-radio-group>
            </span>
            <span
              v-if="form.transactionModeType == 1 && form.transactionMode == 1"
              style="color: #007aff"
            >
              <a @click="openNoticeModal('plan')"
                >《竞价方案须知》<span
                  v-if="hasReadPlanNotice"
                  style="color: #52c41a"
                  >（已查看）</span
                >
                <span
                  v-else
                  style="color: red"
                  >（未查看）</span
                >
                </a
              >
              <a @click="downloadBidderOperatingGuide('guide')">
                《报价人操作指南》<span
                  v-if="hasReadGuideNotice"
                  style="color: #52c41a"
                  >（已查看）</span
                >
                <span
                  v-else
                  style="color: red"
                  >（未查看）</span
                >
              </a>
            </span>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24">
      <div style="width: 80%; margin: auto; line-height: 26px">
        <a-form-model-item
          prop="hasQualificationAudit"
          label="出租方是否对意向承租方进行资格审核"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <div>
            <a-radio-group
              v-model="form.hasQualificationAudit"
              :disabled="
                form.transactionModeType == 1 && form.transactionMode == 5
              "
            >
              <a-radio style="margin: 4px 0px" :value="1">是</a-radio>
              <a-radio style="margin: 4px 0px" :value="0">否</a-radio>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col
      :span="24"
      v-if="form.transactionModeType == 1 && form.transactionMode == 1"
    >
      <div style="width: 80%; margin: auto; line-height: 26px">
        <a-form-model-item
          prop="onlineBiddingMode"
          label="网络竞价模式"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <div>
            <a-radio-group v-model="form.onlineBiddingMode">
              <a-radio style="margin: 4px 0px" :value="1">多次报价</a-radio>

              <a-radio style="margin: 4px 0px" :value="2">一次报价</a-radio>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col
      :span="24"
      v-if="form.transactionModeType == 3 && form.transactionMode == 4"
    >
      <div style="width: 80%; margin: auto; line-height: 26px">
        <a-form-model-item
          prop="otherBidDesc"
          label="其他竞价说明"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea
            v-model="form.otherBidDesc"
            placeholder="请输入其他竞价说明"
            :rows="1"
          />
        </a-form-model-item>
      </div>
    </a-col>

    <!-- 须知弹窗 -->
    <a-modal
      :visible="noticeVisible"
      :width="1000"
      :footer="null"
      :maskClosable="false"
      :keyboard="false"
      :closable="noticeCountdown <= 0"
      @cancel="handleNoticeCancel"
      destroyOnClose
      wrapClassName="notice-modal"
    >
      <div class="notice-modal-title">{{ noticeTitle }}</div>

      <div class="notice-scroll-wrap">
        <div class="notice-content">
          <h1 class="notice-inner-title">{{ noticeInnerTitle }}</h1>
          <div class="notice-text">{{ noticeContent }}</div>
        </div>
      </div>

      <div class="notice-footer-btn">
        <a-button
          type="primary"
          :disabled="noticeCountdown > 0"
          @click="closeNoticeModal"
        >
          {{
            noticeCountdown > 0 ? `请仔细阅读（${noticeCountdown}秒）` : "同意"
          }}
        </a-button>
      </div>
    </a-modal>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      noticeVisible: false,
      noticeType: "",
      noticeCountdown: 5,
      noticeTimer: null,

      // 新增：阅读标志
      hasReadPlanNotice: false,
      hasReadGuideNotice: false,

      noticeMap: {
        plan: {
          title: "竞价方案须知",
          innerTitle: "一次报价竞价须知",
          content: `出租项目出租信息在不动产租赁平台（以下简称“租赁平台”）公开披露，出租方决定通过租赁平台组织竞价，采用网络竞价——一次报价方式确定承租方。
一.竞价底价
      本项目按照招租公告约定的出租底价为竞价底价进行竞价，整个租期的租金按竞价所得的首年租金计算获得。
二.竞价说明
      2.1竞租人应当严格按照竞价须知及报价邀请函规定的程序参与竞价，未按照竞价须知竞价程序及报价邀请函规定的时间递交竞租文件和登陆租赁平台网络竞价平台网络竞价系统的竞租人自动失去竞租资格，不得再参与竞价。
      2.2当通过资格确认的有效竞租人为两家及以上，则通过租赁平台网络竞价平台网络竞价系统，在规定的时间内一次性输入有效报价，确定报价最高的竞租人为承租方。涉及优先承租权的，应根据竞价规则及承租方遴选操作指引中提及的优先权人行使优先承租权原则确定承租方。
      2.3当通过资格确认的有效竞租人仅有一家时，该竞租人则通过租赁平台网络竞价平台网络竞价系统在规定的时间内一次性输入有效报价，成为承租方。
      2.4当出现以下几种情况时，本次竞价活动中止或终结：
            2.4.1当出现下列情况之一时，本次竞价活动中止：
            2.4.1.1在竞价过程中出现不可抗力或网络系统故障或其他因素，导致竞价活动无法正常进行的，组织人可根据上述情况决定竞价活动予以中止（暂停）；
            2.4.1.2组织人确定应当中止竞价活动的其他情形。
            2.4.2竞价中止的，当导致竞价活动无法正常进行的因素消除后，组织人在调整时间后继续开展竞价活动。若竞价记录可以恢复的，在原基础上继续竞价；若竞价记录无法恢复的，重新竞价。出租方和组织人不就竞价活动中止承担任何责任。
            2.4.3当出现下列情况之一时，本次竞价活动终结：
            2.4.3.1应价时间截止，没有竞租人报价的，本次竞价活动终结；
            2.4.3.2最终确定的承租方放弃承租的，本次竞价活动终结；
            2.4.3.3在竞价过程中出现不可抗力或其它因素，导致竞价活动无法正常进行的，组织人认为需要终结的。
      2.5组织人出具竞价结果通知书后，本次竞价活动结束。
三.竞价程序及规则
      3.1竞价程序分为承租确认、竞价邀请、网络竞价、确定竞价结果和承租方、竞价结果通知。
            3.1.1承租确认：竞租人在提交项目报名申请的同时，通过租赁平台线上阅读并确认《承租确认书》。
            3.1.2竞价邀请：组织人向竞租人发出邀请，通知竞价时间、竞价相关参数。
            3.1.3网络竞价：竞租人在规定的时间内登录账号，进入招租项目对应的报价页面进行报价，确定承租方。
            竞租人必须在网络竞价规定时间内进行报价。
            3.1.4确定竞价结果和承租方：根据竞价须知及报价邀请函规则确定承租方。
            3.1.5竞价结果通知：组织人根据竞价结果出具遴选结果通知书。
      3.2规则：
            3.2.1本次以公开竞价确定承租方。
            采用网络竞价平台网络竞价——一次报价的方式确定承租方。一次报价是指，竞租人在组织人规定的报价时间段内仅可提交一次有效报价。网络竞价系统在竞价过程中，不显示任何竞租人的报价记录。报价时间截止后，网络竞价系统按照“价格优先、时间优先”的总体原则，自动判断并显示最高有效报价，该最高报价的竞租人即为承租方。
            3.2.2本次网络竞价活动仅有一个竞租人报价期。
            竞租人报价期：竞租人在规定的时段里自行上网报价，竞租人一旦报价后不得修改，每个竞租人只有一次报价机会，报价时间截止，则当前最高报价的竞租人即成为承租方。
            3.2.3竞租人在规定的时段里自行上网报价，竞租人一旦输入网络竞价系统的交易指令经确认后不得撤回或更改。
            3.2.4竞租人自行选择报价地点，具体竞价操作详见本须知8.2条《报价人操作指南》。
四.竞价时间修改
      出租方修改竞价时间的，应至少在竞价开始日前1个工作日以补充通知的方式通知组织人修改竞价时间，组织人将更新后的竞价时间以补充通知的方式发送各竞租人，并按照修改后的竞价时间组织网络竞价。
五.竞租文件
      5.1竞租文件为《承租确认书》。
      5.2竞租人在提交项目报名申请的同时，通过租赁平台线上阅读并确认《承租确认书》。竞租人一经确认即视为已认可并接受《承租确认书》全部内容。
      5.3承租确认后不得撤销。如竞租人坚持要求撤销的，适用本项目公告及交易规则中有关保证金条款的相关规定。
六.网络竞价、确定承租方
      6.1竞租人应在竞价开始时间前登陆并通过租赁平台网络竞价平台网络竞价系统报价。
      6.2 按以下规则确定承租方：竞租人在规定的时段里自行上网报价，竞租人一旦报价后不得修改，每个竞租人只有一次报价机会，报价时间截止，则当前最高报价的竞租人即成为承租方。涉及优先承租权的，应根据竞价规则及承租方遴选操作指引中提及的优先权人行使优先承租权原则确定承租方。
      6.3因被确定的承租方放弃承租，致使出租方将标的再次挂牌出租，如再次挂牌出租的成交价格低于本次成交价格的，出租方可就差额部分向本项目首次确定的承租方主张损害赔偿。
七.合同签署
      7.1《网络报价结果通知单》中报价结果为承租方在租赁平台网络竞价平台网络竞价系统中的最高报价。组织人依据《网络报价结果通知单》中的最高报价生成《遴选结果通知书》。组织人出具竞价结果通知书后，本次竞价活动结束。
      7.2出租方与承租方应于竞价结束后，租赁双方应根据公告要求或自行约定时间签署《租赁合同》。
八.特别提示
      8.1竞租人一旦线上阅读并确认《承租确认书》即表示已充分了解并接受本竞价方案的全部内容和要求，并不以任何形式对此提出异议，不可撤销地放弃任何索赔的权利。
      8.2竞租人应在竞价前仔细阅读《报价人操作指南》。
      8.3竞租人应在规定的时间里提前做好登陆报价准备，并留有足够的时间报价，避免因网速等因素而影响报价。
      8.4报价时点的确认，系统以到达网络服务器的时间为准。
      8.5竞租人的登录名及报价密码应妥善保管，由于竞租人的原因泄露报价密码所产生的一切后果均自负。
      8.6未经出租方书面同意，竞租人不得向任何第三人披露其所涉及的所有竞价内容、程序以及与此相关的其他内容。
      8.7竞租人应自行承担其参与竞价所涉及的一切费用，任何情况下出租方和组织人均无义务承担此费用。
      8.8竞价方案的解释权归出租方和组织人。`,
        },
        guide: {
          title: "报价人操作指南",
          innerTitle: "报价人操作指南",
          content: `这里放《报价人操作指南》的正文内容。`,
        },
      },
    };
  },
  computed: {
    noticeTitle() {
      return this.noticeMap[this.noticeType]
        ? this.noticeMap[this.noticeType].title
        : "阅读须知";
    },
    noticeInnerTitle() {
      return this.noticeMap[this.noticeType]
        ? this.noticeMap[this.noticeType].innerTitle
        : "";
    },
    noticeContent() {
      return this.noticeMap[this.noticeType]
        ? this.noticeMap[this.noticeType].content
        : "";
    },
  },
  methods: {
    openNoticeModal(type) {
      this.noticeType = type;
      this.noticeVisible = true;
      this.startNoticeCountdown();
    },

    startNoticeCountdown() {
      this.clearNoticeTimer();
      this.noticeCountdown = 5;
      this.noticeTimer = setInterval(() => {
        if (this.noticeCountdown > 0) {
          this.noticeCountdown -= 1;
        } else {
          this.clearNoticeTimer();
        }
      }, 1000);
    },

    closeNoticeModal() {
      if (this.noticeType === "plan") {
        this.hasReadPlanNotice = true;
      }

      this.noticeVisible = false;
      this.clearNoticeTimer();
      this.noticeVisible = false;
      this.clearNoticeTimer();
    },

    handleNoticeCancel() {
      if (this.noticeCountdown > 0) return;
      this.closeNoticeModal();
    },

    clearNoticeTimer() {
      if (this.noticeTimer) {
        clearInterval(this.noticeTimer);
        this.noticeTimer = null;
      }
    },

    handleTransactionModeTypeChange() {
      this.form.transactionMode = undefined;
      this.form.onlineBiddingMode = undefined;
      this.form.otherBidDesc = undefined;
    },

    handleTransactionModeChange() {
      if (
        !(this.form.transactionModeType == 1 && this.form.transactionMode == 1)
      ) {
        this.form.onlineBiddingMode = undefined;
      }

      if (
        !(this.form.transactionModeType == 3 && this.form.transactionMode == 4)
      ) {
        this.form.otherBidDesc = undefined;
      }

      if (
        this.form.transactionModeType == 1 &&
        this.form.transactionMode == 5
      ) {
        this.form.hasQualificationAudit = 0;
      }
    },
    downloadBidderOperatingGuide() {
      this.hasReadGuideNotice = true;
      window.open(
        "https://e-find.oss-cn-shanghai.aliyuncs.com/shexgrp/报价人操作指南.pdf"
      );
    },
  },
};
</script>

<style scoped>
.notice-modal-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #222;
  margin-bottom: 16px;
}

.notice-scroll-wrap {
  max-height: 520px;
  overflow-y: auto;
  padding-right: 18px;
  box-sizing: border-box;
  scrollbar-gutter: stable;
}

.notice-content {
  color: #333;
}

.notice-inner-title {
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  color: #222;
  margin-bottom: 24px;
}

.notice-text {
  line-height: 30px;
  font-size: 14px;
  color: #333;
  white-space: pre-wrap;
  word-break: break-all;
  padding-right: 6px;
}

.notice-footer-btn {
  text-align: center;
  margin-top: 20px;
}

.notice-scroll-wrap::-webkit-scrollbar {
  width: 8px;
}

.notice-scroll-wrap::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 8px;
}

.notice-scroll-wrap::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.22);
  border-radius: 8px;
}

.notice-scroll-wrap::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.32);
}
</style>